import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { FileChooser } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { PersonnelPictureManipulationView } from "./personnelPictureManipulation-view"

export class PersonnelPictureManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف تصویر پرسنل'
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.personnel = ObservableArray.create<personnel>();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation));
        this.refresh();

    }
    GetDefaultView(): View<ViewModel> {
        return new PersonnelPictureManipulationView();
    }
    public getTypeId(): string {
        return "VM-61271e10-e61c-44a3-9a19-6c39770eedd4"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set personnel(v: ObservableArray<personnel>) { this._personnel = v; } public get personnel(): ObservableArray<personnel> { return this._personnel; } private _personnel: ObservableArray<personnel>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;


    async refresh() {
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetAllPersonnelWithPictureInfo', {
                FurtherQueryInfo: filteringInformation
            });
            this.personnel.update(...result.Personnel.map(x => {
                let r = new personnel(this);
                r.id = x.Id;
                r.name = x.Name;
                r.lastname = x.LastName;
                r.identificationCode = x.IdentificationCode;
                r.code = x.PersonnelCode;
                r.hasPicture = x.HasPicture;
                r.pictureFileName = x.PictureFileName;
                r.isPictureLoaded = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
}

export class personnel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set lastname(v: string) { this._lastname = v; } public get lastname(): string { return this._lastname; } private _lastname: string;
    public set identificationCode(v: string) { this._identificationCode = v; } public get identificationCode(): string { return this._identificationCode; } private _identificationCode: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set hasPicture(v: boolean) { this._hasPicture = v; } public get hasPicture(): boolean { return this._hasPicture; } private _hasPicture: boolean;
    public set pictureFileName(v: string) { this._pictureFileName = v; } public get pictureFileName(): string { return this._pictureFileName; } private _pictureFileName: string;
    public set pictureFileData(v: string) { this._pictureFileData = v; } public get pictureFileData(): string { return this._pictureFileData; } private _pictureFileData: string;
    public set isPictureLoaded(v: boolean) { this._isPictureLoaded = v; } public get isPictureLoaded(): boolean { return this._isPictureLoaded; } private _isPictureLoaded: boolean;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadPicture() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/GetPersonnelPicture', {
                PersonnelId: this.id
            });
            this.pictureFileName = result.PictureFileName;
            this.pictureFileData = result.PictureData;
            this.isPictureLoaded = true;
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async addPicture() {
        let fileChooser = new FileChooser();
        let choosedFile = await fileChooser.chooseFile();
        if (choosedFile.isChoosed) {
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/SetPersonnelPicture', {
                    PersonnelId: this.id,
                    PictureFileName: choosedFile.filename,
                    PictureInfo: choosedFile.fileContent
                });
                if (result.IsSuccessful) {
                    this.pictureFileData = choosedFile.fileContent;
                    this.hasPicture = true;
                    this.pictureFileName = choosedFile.filename,
                        this.isPictureLoaded = true;
                    await this.messageBoxConfirmSuccess('عملیات با موفقیت انجام شد', 'عملیات موفق');
                }
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
    async removePicture() {
        try {
            let isRemove = await this.messageBoxDangerYesNo("تصویر حذف شود ؟", "حذف تصویر");
            if (isRemove === "no") {
                return;
            }
            this.isLoading = true;
            await ServerConnection.callServer('/Complex/PersonnelManipulationServices/RemovePersonnelPicture', {
                PersonnelId: this.id
            });
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
        this.hasPicture = false;
        this.isPictureLoaded = false;
        this.pictureFileData = '';
        this.pictureFileName = ''
    }
}